import Drawer from 'components/drawer';
import React from 'react';
import styles from './products.module.scss';
export default function ProductKeys({ fields, drawerActive, setDrawerActive }) {
  return (
    <Drawer
      title="Product Keys"
      setDrawerActive={setDrawerActive}
      drawerActive={drawerActive}
    >
      <Drawer.DrawerBody>
        <p className={styles.transactionDetails__header}>Onboarding Fields</p>
        {fields?.onBoardingFieldsKeys ? (
          fields?.onBoardingFieldsKeys.map((item, index) => {
            return (
              <div
                key={`product-key-${index}`}
                className={styles.transactionDetails__gender__wrapper}
                data-testid="onboarding-keys"
              >
                <div className={styles.transactionDetails__gender}>
                  <p className={styles.transactionDetails__text}>
                    {item?.fieldName}
                  </p>
                  <p className={styles.transactionDetails__value}>
                    {item?.fieldKey ? item?.fieldKey : '-'}
                  </p>
                </div>

                {(item?.subProperties || item.subFields) &&
                  (item.subProperties || item.subFields).map(
                    (subItem, index) => {
                      return (
                        <div
                          key={`product-subItem-${index}`}
                          className={styles.transactionDetails__gender__details}
                          data-testid="subproperties-onboarding-keys"
                        >
                          <p
                            className={styles.transactionDetails__gender__text}
                          >
                            - {subItem?.name}
                          </p>
                          <p className={styles.transactionDetails__value}>
                            {subItem?.id ? subItem?.id : '-'}
                          </p>
                        </div>
                      );
                    },
                  )}
              </div>
            );
          })
        ) : (
          <p style={{ marginTop: '10px' }}>None</p>
        )}

        <p
          className={styles.transactionDetails__header}
          style={{ marginTop: '30px' }}
        >
          Collection Fields
        </p>
        {fields?.collectionFieldsKeys &&
          fields.collectionFieldsKeys.map((item, index) => {
            return (
              <div
                key={`product-key-${index}`}
                className={styles.transactionDetails__gender__wrapper}
                data-testid="collection-keys"
              >
                <div className={styles.transactionDetails__gender}>
                  <p className={styles.transactionDetails__text}>
                    {item?.fieldName}
                  </p>
                  <p className={styles.transactionDetails__value}>
                    {item?.fieldKey ? item?.fieldKey : '-'}
                  </p>
                </div>

                {item?.subFieldKeys &&
                  item.subFieldKeys.map((subItem, index) => {
                    return (
                      <div
                        key={`product-subItem-${index}`}
                        className={styles.transactionDetails__gender__details}
                        data-testid="subproperties-collection-keys"
                      >
                        <p className={styles.transactionDetails__gender__text}>
                          - {subItem?.fieldName}
                        </p>
                        <p className={styles.transactionDetails__value}>
                          {subItem?.fieldKey ? subItem?.fieldKey : '-'}
                        </p>
                      </div>
                    );
                  })}
              </div>
            );
          })}
      </Drawer.DrawerBody>
    </Drawer>
  );
}
